import './index.styl';
import { View } from 'backbone.marionette';
import template from './index.jst';
import Radio from 'backbone.radio';

const adsChannel   = Radio.channel('ads');

export default class RootLayout extends View {
	get template() {
		return template;
	}

	regions() {
		return {
			header:            '#header',
			match_centre:      '#match-centre-game-bar',
			menu:              '#menu',
			main:              'main',
			ads_container:     '#ads-container',
			top_ads_container: '#top-ads-container',
			footer:            '#footer',
			coach:             '#coach-popup',
			user_modal:             '#user-modal',
			global_notification: '#global-notification'
		};
	}

	onRender() {
		this.listenTo(adsChannel, 'destroy-ads', this.destroyAds);
	}

	destroyAds() {
		this.getRegion('ads_container').reset();
		this.getRegion('top_ads_container').reset();
	}
}